import * as types from '../actions/actionTypes';
import initialState from './initialState';

      
        
export default function usuarioReducer(state= initialState.usuario, action){
    let newState;
	switch(action.type){
         case types.LOAD_USUARIO_LIST_SUCCESS:		
            action.usuario.filtroActivo=state.filtroActivo;
            action.usuario.filtroActual=state.filtroActual;
            action.usuario.showActivos=state.showActivos;
			 action.usuario.paginaActual=action.usuario.pageable.pageNumber;
			 action.usuario.registrosPorPagina=action.usuario.size;
            
            return action.usuario;

        case types.BORRAR_USUARIO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(usuario => usuario.id !== action.usuario.id)];          
			return newState;    
            
        case types.ACTIVAR_USUARIO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(usuario => usuario.id !== action.usuario.id)];          
			 return newState;
            
        case types.SET_FILTRO_USUARIO:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}